export const Input = ({
  isError,
  placeholder,
  name,
  type,
  autoComplete,
  id,
  onBlur,
  defaultValue,
  value,
  onChange,
  ...rest
}: InputProps) => {
  return (
    <input
      onBlur={onBlur}
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      id={id}
      name={name}
      type={type}
      autoComplete={autoComplete}
      className={`block w-full rounded border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset transition-all duration-200 text-base ${
        isError
          ? 'ring-red-500 focus:ring-red-500 focus:ring-2'
          : 'ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-slate-500 hover:ring-gray-400'
      }`}
      placeholder={placeholder}
      {...rest}
    />
  )
}

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isError?: boolean
  placeholder: string
  name?: string
  type?: string
  autoComplete?: string
  id: string
}
